import { Box, keyframes } from '@mui/material';
import React from 'react';

const SPIN = keyframes`
	0%, 6.1%    { transform: rotate(0deg); }
	81.8%, 100% { transform: rotate(180deg); }
`;

const PULSE = keyframes`
	0%, 6.1%, 81.8%, 100% { transform: translateY(-27.5px) rotate(45deg) scale(0.75); border-radius: 50%; }
	43.9%                 { transform: translateY(-13.75px) rotate(45deg) scale(1); border-radius: 15.4%; }
`;

const DUR = '1.375s';

const Loader: React.FC = () => (
	<Box
		data-testid="loader-animation"
		sx={{
			position: 'relative',
			width: 88,
			height: 88,
			animation: `${SPIN} ${DUR} cubic-bezier(0.498,0,0.606,1) infinite`
		}}
	>
		{[0, 90, 180, 270].map((deg) => (
			<Box
				key={deg}
				sx={{ position: 'absolute', inset: 0, transform: `rotate(${deg}deg)` }}
			>
				<Box
					sx={{
						position: 'absolute',
						inset: 0,
						margin: 'auto',
						width: 35.75,
						height: 35.75,
						bgcolor: 'primary.main',
						animation: `${PULSE} ${DUR} cubic-bezier(0.333,0,0.667,1) infinite`
					}}
				/>
			</Box>
		))}
	</Box>
);

export default Loader;
